import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core'; 
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { BehaviorSubject } from 'rxjs';
import { AppCommon } from 'src/app/api-providers/app-common'; 
import { StandardResponseModel } from 'src/app/api-providers/models/basic.model';
import { FeedbackFilterModel, FeedbackIndResponseModel, FeedbackModel, FeedbackResponseModel } from 'src/app/api-providers/models/feedback.model';
import { UserDetailModel } from 'src/app/api-providers/models/login.model';
import { Attchment, TaskModel } from 'src/app/api-providers/models/task.model';
import { DownloadService } from 'src/app/api-providers/services/download.service';
import { ApiCollection } from 'src/app/api-providers/services/api-collection';
import { ApiService } from 'src/app/api-providers/services/api-service';
import { ApiServiceDelegate } from 'src/app/api-providers/services/api-service-delegate';
import { TasksViewModel } from 'src/app/api-providers/view-models/tasks.view.model';
import { TasksComponent } from 'src/app/pages/tasks/tasks.component';
import { environment } from 'src/environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';

interface TaskTypeOption {
  id: string;
  name: string;
}

@Component({
  selector: 'app-tasks-drawer',
  templateUrl: './tasks-drawer.component.html',
  styleUrls: ['./tasks-drawer.component.scss'],
  providers: [TasksViewModel]
})

export class TasksDrawerComponent implements OnInit {
  private _AppSelected: string
  @Input()
  set AppSelected(inputApp:string){
    this._AppSelected = inputApp  
  }
  get AppSelected(): string {
    return this._AppSelected;
  }
  fileListUpload= ['.jpg','.jpge','.png','.pdf','.docx','.doc','.ppt','.pptx']
  @Input('showComponent') showComponent = false;
  @Input('applications') applications = [];
  // @Input('statuses') statuses = [];
  @Input('taskDetail') taskDetail: TaskModel;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() taskAdded = new EventEmitter<boolean>();
  @Input('usersResponseModel') usersResponseModel = [];
  typingTimer;                //timer identifier
  doneTypingInterval = 1000;  //time in ms, 5 second for exampl
  isLoading:boolean
  feedBackDetails
  feedbackId:number
  componentCallerName = 'task-drawer';
  taskForm!: UntypedFormGroup;
  loggedInUser: UserDetailModel;
  priorities = AppCommon.getPrioritiesData().results;
  FeedbackFilterModel = new FeedbackFilterModel();
  pageNo= 1
  feedbackListData = []
  feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(new FeedbackResponseModel());
  feedbackModel = new BehaviorSubject<FeedbackIndResponseModel> (new FeedbackIndResponseModel())
  static staticCall;
  fileList: NzUploadFile[] = [ ];
  taskPercent = 0;
  UpcomingDisable:boolean = false
  status = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel);
  statuses:any = []
  isStatusesLoading = false;
  taskTypes: TaskTypeOption[] = [];
  isTaskTypesLoading = false;
  private taskTypesLoaded = false;

 
  quillConfig={
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        // [{ 'direction': 'rtl' }],                         // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean'],                                         // remove formatting button

        ['link'],
        // ['link', 'image', 'video']  
      ],
      
    },}

  constructor(
    private fb: UntypedFormBuilder,
    private vm: TasksViewModel,
    private router: Router,
    private renderer:Renderer2,
    private downloadService: DownloadService,
    private apiService: ApiService,
    private message: NzMessageService
  ) {  
    this.loggedInUser = AppCommon.getloggedInObject().user;
    this.feedbackId = this.router.url.split('/')[1] == 'feedback' ? +this.router.url.split('/')[2] : this.router.url.split('/')[1] == 'my-feedback' ? +this.router.url.split('/')[2] : undefined
    TasksDrawerComponent.staticCall = this;
  }

 

  ngOnInit(): void {
    this.vm.subscribeToTaskDrawer(this.feedbackModel,this.status)
    this.vm.parentComponentDrawer = this;
    this.createForm();
    this.taskDetail == undefined && this.feedbackId !== undefined && this.vm.getFeedbackInd(this.feedbackId);
    // this.taskDetail == undefined &&( this.isLoading = true)
    // if (this.AppSelected && this.AppSelected !='All'){
    //   this.vm.getStatuses(this.AppSelected,'Task-Drawer');
    // }
    this.getStatuses();
    this.getTaskTypes();
  }

  getTaskTypes(){
    if(this.isTaskTypesLoading || this.taskTypesLoaded){
      return;
    }
    this.isTaskTypesLoading = true;
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: ApiCollection.TASK_TYPE,
      Success: (e: any) => {
        this.taskTypes = e?.results || [];
        this.taskTypesLoaded = true;
        this.isTaskTypesLoading = false;
        return '';
      },
      Error: () => {
        this.taskTypes = [];
        this.isTaskTypesLoading = false;
        this.message.error('Error while loading task types', {nzDuration: 1000});
        return '';
      },
    };
    this.apiService.callService(d);
  }

  getStatuses(){

    if(this.AppSelected && this.AppSelected != 'All'){
      this.isStatusesLoading = true;
      this.vm.getStatuses(this.AppSelected,'Task-Drawer');
    }
    
    if (this.taskDetail?.application){
      this.isStatusesLoading = true;
      this.vm.getStatuses(this.taskDetail.application,'Task-Drawer');
    }

  }


  hasAppAccess(user: UserDetailModel, appName: string): boolean {
    return user.application_permission.some(app => app.name === appName);
  }
  
  
  hasActivityPermission(user: UserDetailModel, entity: string, activity: 'Add' | 'Update' | 'Remove'): boolean {
    const activityPermission = `${activity} ${entity}`;
    return user.permission.some(perm => perm.name === activityPermission);
  }

  getAssignableUsers(){
    return (this.usersResponseModel || []).filter((user: any) => user?.id != null && this.getUserOptionLabel(user));
  }

  getUserOptionLabel(user: any){
    return (user?.user_name || user?.name || user?.full_name || user?.email || '').trim();
  }

  getSpeechToText(e){
    let v = ''
    // console.log(this.taskForm.get('description').value.toLowerCase().trim() != e.trim() ,!this.taskForm.get('description').value.toLowerCase().trim().includes(e.trim()), this.taskForm.get('description').value.toLowerCase().trim() , e.trim())
    if(this.taskForm.get('description').value && this.taskForm.get('description').value.toLowerCase().trim() != e.trim() && !this.taskForm.get('description').value.toLowerCase().trim().includes(e.trim())) {
      v = this.taskForm.get('description').value + e
    } else{
      v = e
    }
    this.taskForm.controls.description.setValue(v) 
  }

  onSelectionChanged = (event) =>{
    if(event.oldRange == null){
 
    }
    if(event.range == null){
 
    }
  }

  // onContentChanged = (event) =>{
  //   //console.log(event.html);
  // }

  open(): void {
    this.showComponent = true; 
    this.setValueForm()
  }

  createForm(){
    this.taskForm = this.fb.group({
      application: [null, [Validators.required]],
      name: [null, [Validators.required]],
      priority: [null, [Validators.required]],
      description: [''],
      due_date: [null, [Validators.required]],
      task_status: [null, [Validators.required]],
      is_upcoming_release:[false],
      link_feedback: [{value:null, disabled: false}],
      assigned_to: [null],
      task_type: [[], [Validators.required]],
      progress: [0]
    });
 
     
    this.feedbackId == undefined && this.setValueForm()
  }

  titleAdded(){
    if(!this.taskForm.value.description){
      this.taskForm.controls.description.setValue(this.taskForm.value.name) 
    }
    
  }
 
  feedbackReceived(){
    // this.feedBackDetails = [].concat(this.feedbackResponseModel.value.results).filter( e => e.id == this.feedbackId)[0]
    this.feedBackDetails = this.feedbackModel.value
    console.log(this.feedBackDetails)
    this.taskDetail == undefined &&(this.isLoading = false) ;
    // this.feedbackListData = this.feedbackResponseModel.value.results
    this.feedBackDetails && this.setValueForm()
  }

  getStatusId(status_string) {
    // console.log(status_string,this.status.value.results)
    const statuses = this.status.value.results;
    if (!statuses?.length) return null;
    const item = statuses.find(e => e.name.toLowerCase() === status_string.toLowerCase());
    // console.log(item ,statuses )
    return item ? item.id : null;
  }
  
  
  setValueForm(){
    let today:any = new Date();
    let dd:any = today.getDate();
    let mm:any = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
      }
      if (mm < 10) {
          mm = '0' + mm;
      }
      today = yyyy + '-' + mm + '-' +  dd;

    let taskDetail = {
      application:undefined, 
      name: undefined,
      priority: undefined,
      description: undefined,
      task_status: undefined,
      link_feedback: undefined,
      assigned_to: undefined,
      task_type: [],
      due_date:undefined,
      is_upcoming_release:undefined,
      feedback_name:undefined,
      progress:0
    }
 
    if(this.taskDetail){
    taskDetail.application =   this.taskDetail.application  
    taskDetail.name =   this.taskDetail.name 
    taskDetail.description =   this.taskDetail.description  
    taskDetail.assigned_to =   this.taskDetail.assigned_to 
    taskDetail.task_type =   this.taskDetail.task_type || []
    taskDetail.task_status =   this.taskDetail.task_status 
    taskDetail.priority =   this.taskDetail.priority 
    taskDetail.link_feedback =   this.taskDetail.link_feedback 
    taskDetail.due_date =  this.taskDetail.due_date
    taskDetail.is_upcoming_release =  this.taskDetail.is_upcoming_release
    taskDetail.progress =  this.taskDetail.progress
    this.fileList = JSON.parse(JSON.stringify(this.taskDetail.task_attachment));

    }else if(this.feedBackDetails){
    taskDetail.application =   this.feedBackDetails.application  
    taskDetail.name =  this.feedBackDetails.title  
    taskDetail.description =   this.feedBackDetails.description  
    taskDetail.assigned_to =  this.feedBackDetails.assigned_to 
    taskDetail.link_feedback =   this.feedBackDetails.id  
    taskDetail.feedback_name =   this.feedBackDetails.title  
    taskDetail.priority = 1
    taskDetail.task_status = this.getStatusId('in-progress');
    taskDetail.due_date = today; 
    this.fileList = JSON.parse(JSON.stringify(this.feedBackDetails.attachment));
    taskDetail.is_upcoming_release = false
    }

    if( this.AppSelected != '' && !this.taskDetail && !this.feedBackDetails ){
      taskDetail.application = this.AppSelected;
      taskDetail.task_status = this.getStatusId('in-progress');
    }
    if( !this.taskDetail && !this.feedBackDetails ){
      taskDetail.due_date = today;
      taskDetail.priority = 3
      taskDetail.task_status = this.getStatusId('in-progress');
    }

    if(this.taskDetail && this.taskDetail.link_feedback && this.taskDetail.feedback_name  ){
      this.feedbackListData = []
      let obj = {}
      obj['id'] = this.taskDetail.link_feedback 
      obj['title'] = this.taskDetail.feedback_name 
      this.feedbackListData.push(obj)
    }
    
    this.fileList.forEach(element => {
      var name = element.url.split('/')
      element.name = name[name.length - 1]
      element.media_url = element.url
      element.url = environment.api_url + element.url 
      element.status = 'done'
      element.id = element.media_id ? element.media_id : element.id
    });
    this.taskForm.patchValue(taskDetail)
    this.checkUpcomingDisable()  
   }

   statusChange(e){
    if( e == 2 || e == 6 || e == 7){
      this.UpcomingDisable = false
    } else{
      this.UpcomingDisable = true
      this.taskForm.get('is_upcoming_release').setValue(false) 
    }
   }

   checkUpcomingDisable(){
    if(this.taskDetail && this.taskDetail.status && ( 
      this.taskDetail.task_status == this.getStatusId('in-progress') 
      || this.taskDetail.task_status == this.getStatusId('pending on production') 
      || this.taskDetail.task_status == this.getStatusId('qa'))){
      this.UpcomingDisable =  false
    } else {
      this.UpcomingDisable = true
    }
   }

   updateUpcoming(){
    this.taskForm.get('is_upcoming_release').setValue(!this.taskForm.get('is_upcoming_release').value)
   }

  inputkeyUp(e) {
    clearTimeout(this.typingTimer);
    this.FeedbackFilterModel.title = e.target.value
    this.typingTimer = setTimeout(this.searchFeedback.bind(this), this.doneTypingInterval);
  };

 
  inputKeyDown() {
    clearTimeout(this.typingTimer);
  };


   searchFeedback(e){
    let first = this.FeedbackFilterModel.title.length -1 
    if(this.FeedbackFilterModel.title.length > 2){
      this.vm.getFeedbacks(this.pageNo, this.FeedbackFilterModel);
    } else if(first > 0) {
      this.vm.getFeedbacks(this.pageNo, this.FeedbackFilterModel);
    }
  
    
   }

   
  downloadUpload = (file: NzUploadFile): boolean => {
    this.vm.downloadMedia(file.media_url, file.name)
    return false;
  };

  fileDownloaded(res, name){
    this.downloadService.download(res, name);
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.vm.uploadMedia(file, this.loggedInUser.id, file.name)
    return false;
  };

  removeUpload = (file: NzUploadFile): boolean => {
    this.vm.removeMedia(file.id);
    return false;
  };


  attachmentRemoved(file_id){
    const arr = this.fileList.filter(x => x.id !== file_id);
    this.fileList = arr;
  }



  fileUploaded(e: NzUploadFile){
    e.status = 'done';
    this.fileList = this.fileList.concat(e);
  }

  fileUploadedError(){

  }
  
    
  close(): void {
    this.showComponent = false;
    this.closeEvent.emit(this.showComponent);
    if(!this.taskDetail) {
      this.taskForm.reset() 
    } 
  }

  submitForm(): void{
    if (this.taskForm.valid) {
      var model = new TaskModel();
      let files = this.fileList.map((e: any) => e.id)
      model.application = this.taskForm.value.application;
      model.name = this.taskForm.value.name;
      model.description = this.taskForm.value.description ? this.taskForm.value.description :  this.taskForm.value.name;
      model.link_feedback = this.taskForm.value.link_feedback;
      model.priority = this.taskForm.value.priority;
      model.assigned_to = this.taskForm.value.assigned_to;
      model.task_status = this.taskForm.value.task_status;
      model.task_type = this.taskForm.value.task_type || [];
      model.due_date = this.taskForm.value.due_date;
      model.progress = this.taskForm.value.progress;
      model.attachments = []
      model.attachments.push(...files)
      model.is_upcoming_release = this.taskForm.value.is_upcoming_release ;
      if(this.taskForm.value.task_status == this.getStatusId('completed')){
        model.progress = 100
      }
      if(this.taskDetail){
        model.modified_by = this.loggedInUser.id;
        this.isLoading = true
        this.vm.updateTask(this.taskDetail.id, model, this.componentCallerName)
      } else {
        model.created_by = this.loggedInUser.id;
        this.isLoading = true
        this.vm.createTask(model);
      }

    } else {
      Object.values(this.taskForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  increase(): void {
    this.taskPercent = this.taskForm.get('progress').value + 10;
    if (this.taskPercent > 100) {
      this.taskPercent = 100;
    }
    this.taskForm.get('progress').setValue(this.taskPercent) 
    // this.updateTaskProgress();
  }

  decline(): void {
    this.taskPercent = this.taskForm.get('progress').value - 10;
    if (this.taskPercent < 0) {
      this.taskPercent = 0;
    }
    this.taskForm.get('progress').setValue(this.taskPercent) 
    // this.updateTaskProgress();
  }


  
  updateTaskProgress(){
    // this.taskForm.get('progress').setValue(this.taskPercent) 
    
    if(this.taskPercent === 100){
        this.taskForm.get('task_status').setValue(this.getStatusId("completed")) 
          // payload['task_status'] = this.getStatusId("completed");
        } else {
        this.taskForm.get('task_status').setValue(this.getStatusId("in-progress")) 
          // payload['task_status'] = this.getStatusId("in-progress");
    }

    // var payload = {progress: this.taskPercent};
    // if(this.taskPercent > 0){
    //   if(this.taskPercent === 100){
    //     payload['task_status'] = this.getStatusId("completed");
    //   } else {
    //     payload['task_status'] = this.getStatusId("in-progress");
    //   }
    // } 
    // payload['modified_by'] = this.loggedInUser.id;
    // this.vm.updateTask(
    //   this.taskDetail.id, payload, this.componentCallerName
    // );
  }


  taskUpdated(){
    this.isLoading = false
    this.close();
    this.taskAdded.emit(true)
  }

  errorOnTaskUpdate(){
    
  }
  statusesReceived(){
  
    this.statuses = this.status.value.results;
    this.isStatusesLoading = false;

    let taskDetail = {
      task_status: undefined,
    }
 
    if(this.feedBackDetails){
    taskDetail.task_status = this.getStatusId('in-progress');
    }
    if( this.AppSelected != '' && !this.taskDetail && !this.feedBackDetails ){
      taskDetail.task_status = this.getStatusId('in-progress');
    }
    if( !this.taskDetail && !this.feedBackDetails ){
      taskDetail.task_status = this.getStatusId('in-progress');
    }

    taskDetail.task_status !== undefined && this.taskForm.patchValue(taskDetail)
   
  }

  statusesLoadFailed(){
    this.statuses = [];
    this.isStatusesLoading = false;
  }

  onSelectApp(id){
    this.statuses = [];
    this.taskForm.get('task_status').setValue(null);
    if(!id){
      this.isStatusesLoading = false;
      return;
    }
    this.isStatusesLoading = true;
    this.vm.getStatuses(id,'Task-Drawer');
  }

}
